import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DYKTip } from '@models/edp/dyk-tips.model';
import { SiqPopupHelper } from '@shared/utils/helpers/siq-popup.helper';
import { Observable, catchError, map, throwError } from 'rxjs';
import { EnvironmentsService } from './environments.service';
import { MixpanelService } from './mixpanel.service';
import { SiqApiService } from './siq-api.service';
import { SplashScreenService } from './splash-screen.service';

@Injectable({
  providedIn: 'root'
})
export class EdpService extends SiqApiService {

  constructor(
    httpClient: HttpClient,
    environmentService: EnvironmentsService,
    mixpanelService: MixpanelService,
    siqPopupHelper: SiqPopupHelper,
    splashScreenService: SplashScreenService) {
    super(httpClient, environmentService, mixpanelService, siqPopupHelper, splashScreenService);
  }

  getDYKTips(sleeperId: string): Observable<Array<DYKTip>> {
    return this.makeEdpRequest<Array<DYKTip>, object>(`tips/${sleeperId}`, {}, 'GET').pipe(
      map((response: Array<DYKTip> | HttpErrorResponse) => {
        if (response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }
}
